export enum ContentSource {
  Internal = "Internal",
  Konodrac = "Konodrac",
  Brightcove = "Brightcove",
}
